import { render, staticRenderFns } from "./ProductSingle.vue?vue&type=template&id=47f0c735"
import script from "./ProductSingle.vue?vue&type=script&lang=js"
export * from "./ProductSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports